var React = require('react');

function Person (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m16 18c-3.3137085 0-6-2.6862915-6-6s2.6862915-6 6-6 6 2.6862915 6 6-2.6862915 6-6 6zm0-2c2.209139 0 4-1.790861 4-4s-1.790861-4-4-4-4 1.790861-4 4 1.790861 4 4 4zm-7 10h-2v-1c0-3.3137085 2.6862915-6 6-6h6c3.3137085 0 6 2.6862915 6 6v1h-2v-1c0-2.209139-1.790861-4-4-4h-6c-2.209139 0-4 1.790861-4 4z","fill":"#42484d"}));
}

Person.defaultProps = {"height":"32","viewBox":"0 0 32 32","width":"32"};

module.exports = Person;

Person.default = Person;
